import React from "react";

import styles from "./HelpHero.module.scss";

const HelpHero = () => {
  return (
    <div className={styles.hero}>
      <p className={styles.heading}>お困りの際は、以下を順にお試しください。</p>
    </div>
  );
};

export default HelpHero;
